import { render, staticRenderFns } from "./DashBoardResponsibleComponent.vue?vue&type=template&id=675f2801&scoped=true&"
import script from "./DashBoardResponsibleComponent.vue?vue&type=script&lang=js&"
export * from "./DashBoardResponsibleComponent.vue?vue&type=script&lang=js&"
import style0 from "./DashBoardResponsibleComponent.vue?vue&type=style&index=0&id=675f2801&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f2801",
  null
  
)

export default component.exports